import { Injectable } from '@angular/core';
import { GroupModel, UserGroupModel } from 'src/app/admin/models/group.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { CreateSurvey } from '../components/page/page.model';
import { SurveyModel } from 'src/app/dashboard/dashboard.model';
import { CreateBusinessProcessModel } from 'src/app/create/models/businessProcess.model';
import { WorkflowStepAssignedView } from 'src/app/create/models/workflowStepAssignedView.model';
import { CreateEntity } from 'src/app/create/models/entity.model';
import { WorkflowView } from 'src/app/create/models/workflowView.model';
import { IDispute } from '../models/dispute/dispute.model';
import { IDisputeConfig } from '../models/dispute/disputeConfig.model';

@Injectable({
  providedIn: 'root'
})
export class GlobalsessionhandlerService {

  private organizationId: string;
  private groupId: string;
  private favOrganizationId: string;
  private favGroupId: string;
  private templateOrganizationId: string;
  private templateGroupId: string;
  private surveyId:string;
  private authorized:boolean=false;
  private surveyStatus:string;
  private IsEsignReq:boolean=false;
  private loggedInUserName:string='';
  private isAnonymousUser : boolean=false;
  private survey : CreateSurvey;
  private entityId:string;
  private bussinessProcessId:string;
  private incidentId:number;
  private userGroupId:string;
  private mySurvey : SurveyModel[]=[];
  private businessProcess : CreateBusinessProcessModel;
  private surveySettings: CreateSurvey;
  private stepNavigated:any;
  private surveyInstanceId :string;
  private entityObj :CreateEntity;
  private viewIconFlag : boolean =false;
  private groupObject:GroupModel;
  private workflow : WorkflowView;
  private raiseDisputeFlag : boolean =false;
  private dispute : IDispute;
  private surveyDisputeConfig : IDisputeConfig;
  private mappedMeasureReviewDetailsSubject = new BehaviorSubject<Record<number, any>>({});


  getSurvey(){
    return this.survey;
  }
  setSurvey(survey : CreateSurvey){
    this.survey= survey;
  }
  getSurveyWorkFlow(){
    return this.workflow;
  }
  setSurveyWorkflow(wf : WorkflowView){
    this.workflow= wf;
  }
  getMySurvey(){
    return this.mySurvey;
  }
  setMySurvey(mySurvey : SurveyModel[]){
    this.mySurvey = mySurvey;
  }

  getSurveySettings(){
    return this.surveySettings;
  }
  setSurveySettings(surveySettings: CreateSurvey){
    this.surveySettings = surveySettings;
  }

  getBusinessProcess(){
    
    return this.businessProcess;
  }
  setBusinessProcess(businessProcess: CreateBusinessProcessModel){
    this.businessProcess = businessProcess;
  }

  setAnonymousUser ( isAnonymousUser : boolean)
{
  this.isAnonymousUser = isAnonymousUser;
}
getAnonymousUser (){
  return this.isAnonymousUser;
}
 
  setLoggedInUserName(name :any)
  {
this.loggedInUserName=name;
  }

  getLoggedInUserName()
  {
   return this.loggedInUserName;
  }

  GetESignReq()
  {
    return this.IsEsignReq;
  }

  SetESignReq(value)
  {
    this.IsEsignReq=value;
  }
  // Observable string sources
  public loginSuccess = new Subject<any>();
  loginEmitted$ = this.loginSuccess.asObservable();
  emitloginSucessful(message: boolean) {
    this.loginSuccess.next(message);
  }

  permissions:UserGroupModel[]=[] ; // Store the actions for which this user has permission


    clearSession()
    {
      this.organizationId="";
      this.IsEsignReq=false;
      this.groupId="";
      this.favGroupId="";
      this.favOrganizationId="";
      this.templateGroupId="";
      this.templateOrganizationId="";
      this.surveyId="";
      this.surveyStatus="";
      this.permissions=[];
      this.loggedInUserName="";
      this.isAnonymousUser = false;
      this.entityId ="";
      this.bussinessProcessId = "";
      this.incidentId=0;
      this.mySurvey=[];
      this.survey=<CreateSurvey>{};
      this.businessProcess=<CreateBusinessProcessModel>{};
      this.surveySettings=<CreateSurvey>{};
      this.stepNavigated = null;
      this.surveyInstanceId = "";
      this.entityObj = new CreateEntity();
      this.viewIconFlag = false;
      this.clearMappedMeasureReviewDetails();
    }

    setuserpermission(val) {
      this.permissions = val;
    }
    getuserpermission() {
        return this.permissions;
    }
  //Survey Session handler

  setSurveyStatus(val) {
    this.surveyStatus = val;
  }
  getSurveyStatus() {
      return this.surveyStatus;
  }

  setAuthorizationflag(val) {
    this.authorized = val;
  }
  getAuthorizationflag() {
      return this.authorized;
  }

  setSurveyId(val) {
    this.surveyId = val;
  }
  getSurveyId() {
      return this.surveyId;
  }

  setOrganizationId(val) {
      this.organizationId = val;
  }
  getGroupId() {
      return this.groupId;
  }
  setGroupId(val) {
    this.groupId = val;
  }
  getOrganizationId() {
    return this.organizationId;
  }
  
//Favorite Session handler
setFavOrganizationId(val) {
  this.favOrganizationId = val;
}
getFavGroupId() {
  return this.favGroupId;
}
setFavGroupId(val) {
this.favGroupId = val;
}
getFavOrganizationId() {
return this.favOrganizationId;
}

//Template Session handler
setTemplateOrganizationId(val) {
  this.templateOrganizationId = val;
}
getTemplateGroupId() {
  return this.templateGroupId;
}
setTemplateGroupId(val) {
this.templateGroupId = val;
}
getTemplateOrganizationId() {
return this.templateOrganizationId;
}

getEntityId( ){
  return this.entityId;
}
setEntityId(entityId:string){
  this.entityId= entityId;
}

getBussinessProcessId(){
  return this.bussinessProcessId;
}
setBussinessProcessId(processId:string){
  this.bussinessProcessId= processId;
}

getIncidentId(){
  return this.incidentId;
}
setIncidentId(incidentId:number){
  this.incidentId= incidentId;
}



setUserGroupId(groupId :string){
  this.userGroupId = groupId;
}
getUserGroupId(){
   return this.userGroupId;
}

  setNavigatedStep(data :any){
    this.stepNavigated = data;
  }
  getNavigatedStep(){
    return this.stepNavigated;
  }

  setSurveyInstanceId(data :any){
    this.surveyInstanceId = data;
  }
  getSurveyInstanceId(){
    return this.surveyInstanceId;
  }

  
getEntityObj(){
  return this.entityObj;
}
setEntityObj(entity: CreateEntity){
  this.entityObj = entity;
}


  setViewIconFlag(flag :boolean){
    this.viewIconFlag = flag;
  }
  getViewIconFlag(){
    return this.viewIconFlag;
  }
  setSelectedGroupObj(group){
     this.groupObject=group;
  }
  getSelectedGroupObj(){
   return this.groupObject;
 }

  setRaiseDisputeFlag(flag :boolean){
    this.raiseDisputeFlag = flag;
  }
  getRaiseDisputeFlag(){
    return this.raiseDisputeFlag;
  }

  setDispute(dispute: IDispute){
    this.dispute = dispute;
  }
  getDispute(): IDispute {
    return this.dispute;
  }

  setSurveyDisputeConfig(config: IDisputeConfig){
    this.surveyDisputeConfig = config;
  }
  getSurveyDisputeConfig(): IDisputeConfig {
    return this.surveyDisputeConfig;
  }

  setMappedMeasureReviewDetails(data: Record<number, any>): void {
    this.mappedMeasureReviewDetailsSubject.next(data || {});
  }

  getMappedMeasureReviewDetails(): Record<number, any> {
    return this.mappedMeasureReviewDetailsSubject.getValue() || {};
  }

  mappedMeasureReviewDetails$(): Observable<Record<number, any>> {
    return this.mappedMeasureReviewDetailsSubject.asObservable();
  }

  clearMappedMeasureReviewDetails(): void {
    this.mappedMeasureReviewDetailsSubject.next({});
  }
}
